export default __webpack_public_path__ + "static/media/collection_illustration.7c612ad7.svg";